export default "__VITE_ASSET__BYMCz_d3__"